import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Stack, Button, Icon, Divider } from 'investira.react.components';
import { Assinar } from '../';

const BulkContextActions = memo(props => {
  const {
    recurso,
    onDeleteClick,
    selectedRows,
    assinatura = false,
    isInvalidRows = false,
    refreshData
  } = props;

  return (
    <Stack justifyContent="center" sx={{ height: '40px', marginRight: 2 }} flexGrow={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" flexGrow={1}>
        <Stack direction="row" spacing={2}>
          {onDeleteClick && (
            <Button
              disabled={props.disabled}
              variant="contained"
              color="error"
              startIcon={<Icon iconName="delete" size={16} />}
              size="small"
              sx={{ px: 2 }}
              onClick={() => onDeleteClick(selectedRows)}>
              Excluir
            </Button>
          )}
        </Stack>
        {assinatura && (
          <Assinar
            recurso={recurso}
            disabled={props.disabled || isInvalidRows}
            size="small"
            data={selectedRows.map(xRow => xRow.original)}
            refreshData={refreshData}
          />
        )}
      </Stack>
    </Stack>
  );
});

BulkContextActions.propTypes = {
  disabled: PropTypes.bool
};

export default BulkContextActions;
